// frontend/src/components/librarian/ui/Monogram.tsx
import React from 'react';

const SIZES = {
  /** Table rows. */
  sm: 'w-8 h-8 font-mono text-[11px]',
  /** Record pages. Set in the serif, like a monogram on a title page. */
  lg: 'w-24 h-24 font-serif text-[36px] tracking-wide',
} as const;

const SHAPES = {
  /** People (authors). */
  round: 'rounded-full',
  /** Organisations (publishers): a colophon block rather than a face. */
  square: 'rounded-md',
} as const;

interface Props {
  text: string;
  size?: keyof typeof SIZES;
  shape?: keyof typeof SHAPES;
}

/** Initials block. Decorative: the name always sits beside it. `--lib-surface` on
 *  `--lib-navy` holds contrast in both themes (navy lifts to a light tint on dark). */
const Monogram: React.FC<Props> = ({ text, size = 'sm', shape = 'round' }) => (
  <span
    aria-hidden
    className={`${SIZES[size]} ${SHAPES[shape]} shrink-0 bg-[var(--lib-navy)] text-[var(--lib-surface)] inline-flex items-center justify-center select-none`}
  >
    {text}
  </span>
);

export default Monogram;
